import { useState, useEffect } from "react";
import useApi from "@/hooks/useApi";

/**
 * Reads the resolved entitlement feature map for the current site from
 * GET /Entitlements/my (admin API). Distinct from useAdminFeatures (v20 legacy
 * Subscription.cs-mirrored /Features endpoint) and useSubscriptions (v10 flags).
 *
 * Use this for any NEW capability seeded via EntitlementFeatureSeeder.GetCanonicalFeatures()
 * — never add a new entitlement-only flag to Subscription.cs or SubscriptionsProvider.tsx.
 *
 * loading=true while the first fetch is in-flight; gates should render null
 * instead of "not enabled" during that window.
 */
export default function useEntitlements(): { features: Record<string, boolean>; loading: boolean } {
  const api = useApi();
  const [features, setFeatures] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.admin
      .get("Entitlements/my")
      .then((res) => res.json())
      .then((data) => {
        setFeatures(data?.features ?? {});
      })
      .catch(() => {
        // Non-fatal — keep defaults (all entitlements resolve to "not enabled")
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { features, loading };
}
